import { useState } from 'react';

interface Props {
  offerTitle: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
  loading?: boolean;
}

export default function RefuseModal({ offerTitle, onConfirm, onCancel, loading }: Props) {
  const [reason, setReason] = useState('');

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (reason.trim()) onConfirm(reason.trim());
  }

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="modal">
        <div className="modal-title">Refuser l'offre</div>
        <div className="modal-desc">
          Vous refusez <strong style={{ color: 'var(--text)' }}>«&nbsp;{offerTitle}&nbsp;»</strong>.
          Un motif est obligatoire — il sera visible par l'hôte.
        </div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="refuse-reason">Motif du refus</label>
          <textarea
            id="refuse-reason"
            placeholder="Ex : Photos non conformes, description insuffisante…"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            autoFocus
          />

          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={loading}>
              Annuler
            </button>
            <button
              type="submit"
              className="btn btn-danger"
              disabled={!reason.trim() || loading}
            >
              {loading ? <span className="spinner" /> : '✕'}
              Refuser
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
